<template>
  <qx-card title="列表">
    <span slot="titleLeft">
      【未开票：
      <span class="primary">{{
        tableData.originData.openBillAmountWait || 0
      }}</span
      >】 【待确认收票：
      <span class="primary">{{
        tableData.originData.openBillAmountHas || 0
      }}</span
      >】 【已收票：
      <span class="primary">{{
        tableData.originData.openBillAmountOk || 0
      }}</span
      >】
    </span>
    <LogRightDialog ref="logRightDialog" busiCode="22000025" />
    <section slot="titleRight">
      <qx-permpisions permpisions="2000913">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="billManageBO.ajax?cmd=doQueryInvoice"
          :params="fullSearchData"
          bizName="开发票记录信息导出"
          bizCode="exp20002"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>

      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section
                  v-if="scope.column.property === 'busiCode'"
                  @click="toCarCostDetail(scope.row)"
                >
                  <span class="primary">{{
                    scope.row[scope.column.property]
                  }}</span>
                </section>
                <section
                  v-if="
                    scope.column.property !== 'orderId' &&
                    scope.column.property !== 'busiCode'
                  "
                >
                  {{ scope.row[scope.column.property] }}
                </section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            fixed="right"
            width="180"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :btnList="[
                  {
                    permpisions: '2000911',
                    showCondition: scope.row.billState === 1,
                    name: '开票',
                    event: () => toEdit(scope.row.flowId),
                  },
                  {
                    permpisions: '2000912',
                    showCondition: scope.row.billState === 2,
                    name: '修改发票',
                    event: () => toEdit(scope.row.flowId),
                  },
                  {
                    showCondition: true,
                    name: '日志',
                    event: () => showLog(scope.row.flowId),
                  },
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import LogRightDialog from 'components/logRightDialog';
import ExportBtn from 'components/exportBtn';
import TableBtn from 'components/tableBtn/tableBtn';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  invoiceRegisterList,
} from 'api/operate';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
    ExportBtn,
    TableBtn,
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        originData: {},
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'applyNum', label: '申请号码', fixed: true },
          { prop: 'createDate', label: '申请时间' },
          { prop: 'applyUserName', label: '申请方' },
          { prop: 'orderNum', label: '订单数' },
          { prop: 'openBillAmountDouble', label: '开票总金额' },
          { prop: 'invoiceNumber', label: '发票号码' },
          { prop: 'expressNumber', label: '快递单号' },
          { prop: 'billStateName', label: '状态' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: invoiceRegisterList,
    showLog (id) {
      this.$refs.logRightDialog.show(id);
    },
    toEdit (id) {
      this.jump({
        label: (id ? '修改' : '新增') + '发票',
        url: `/manage/operate/invoice/register/edit${id ? '?id=' + id : ''}`,
        full: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
